// src/gameLogics/pilahSampahData.js
export const questionsByDifficulty = {
  easy: [
    { text: "Kulit Pisang", answer: "organic" },
    { text: "Botol Plastik", answer: "inorganic" },
    { text: "Sisa Nasi", answer: "organic" },
    { text: "Kertas Koran", answer: "inorganic" },
    { text: "Daun Kering", answer: "organic" },
    { text: "Kaleng Minuman", answer: "inorganic" },
    { text: "Sayuran Busuk", answer: "organic" },
    { text: "Kardus Bekas", answer: "inorganic" },
  ],
  medium: [
    { text: "Baterai Bekas", answer: "b3" },
    { text: "Styrofoam Bekas", answer: "inorganic" },
    { text: "Tulang Ayam", answer: "organic" },
    { text: "Kemasan Tetra Pak", answer: "inorganic" },
    { text: "Obat Kadaluarsa", answer: "b3" },
    { text: "Plastik Pembungkus", answer: "inorganic" },
    { text: "Rambut Rontok", answer: "organic" },
    { text: "CD/DVD Rusak", answer: "inorganic" },
  ],
  pro: [
    { text: "Sisa Lem Cair", answer: "b3" },
    { text: "Cat Bekas", answer: "b3" },
    { text: "Oli Motor", answer: "b3" },
    { text: "Lampu Neon", answer: "b3" },
    { text: "Aki Bekas", answer: "b3" },
    { text: "Filter Rokok", answer: "inorganic" },
    { text: "Kain Pel Kotor", answer: "organic" },
    { text: "Popok Bayi Bekas", answer: "organic" },
  ],
};